<template>
  <div :class="$style.page">
    <div :class="[$style.row, $style.header]">
      <div :class="$style.content">
        <div :class="$style.left">
          <img src="/icons/analytics/layers.svg" alt="" />
        </div>
        <div :class="$style.right">
          <div :class="[$style.column, $style.id]">Id</div>
          <div :class="[$style.column, $style.date]">Дата</div>
          <div :class="$style.column">Организ.</div>
          <div :class="[$style.column, $style.period]">Работник</div>
          <div :class="[$style.column, $style.period]">Наблюдатель</div>
          <div :class="$style.column">Время начала</div>
          <div :class="$style.column">Время окончания</div>
          <div :class="[$style.column]">Продолжит.</div>
          <div :class="[$style.column]">Комментарий админа</div>
        </div>
      </div>
    </div>
    <SupervisionRow
      v-for="item in supervisions"
      :key="item.id"
      :item="item"
      :supervision="supervision"
      @open="$emit('open', $event)"
      @setVerified="$emit('setVerified', $event)"
      @setVerifiedItem="$emit('setVerifiedItem', $event)"
      @openModal="$emit('openModal', $event)"
      @openImage="(comment, image) => $emit('openImage', comment, image)"
    />
  </div>
</template>

<script>
import SupervisionRow from "./SupervisionRow.vue";

export default {
  name: "SupervisionTable",
  components: {
    SupervisionRow,
  },
  props: {
    supervisions: {
      type: Array,
      default: () => [],
    },
    supervision: {
      type: Object,
      default: () => ({}),
    },
  },
  emits: ["open", "setVerified", "setVerifiedItem", "openModal", "openImage"],
};
</script>

<style lang="scss" module>
.page {
  padding: 0 1rem 1rem 1rem;
  background-color: $background;
  flex: 1 1 auto;
  min-height: 100vh;
  overflow: auto;
  @include scrollbarY;
  @include scrollbarX;
  .row {
    font-weight: 400;
    background-color: $bg-white;
    border-radius: 0.125rem;
    border-bottom: 0.125rem solid $background;
    cursor: pointer;
    &.header {
      border-radius: 0.75rem 0.75rem 0 0;
      background-color: $gray;
      color: $t-white;
      font-weight: 700;
      cursor: auto;
    }
    .content {
      display: flex;
      align-items: center;
      padding: 1rem;
      gap: 1rem;
      .left {
        flex: 0 0 1.5rem;
        height: 1.5rem;
        cursor: pointer;
      }
      .right {
        flex: 1 1 auto;
        display: flex;
        justify-content: space-between;
        gap: 1rem;
        .column {
          flex: 0 1 7rem;
          display: flex;
          align-items: center;
          &.id {
            flex: 0 0 3.5rem;
          }
          &.date {
            flex: 0 0 6rem;
          }
          &.period {
            flex: 0 0 11.5rem;
          }
        }
      }
    }
  }
}
</style>

